"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRestResponse = isRestResponse;
/* eslint-disable @typescript-eslint/naming-convention -- using names from external type defs */

function isRestResponse(response) {
  if (typeof response !== 'object' || response === null) {
    return false;
  }
  const {
    _response
  } = response;
  if (typeof _response !== 'object') {
    return false;
  }
  return typeof _response.status === 'number';
}
//# sourceMappingURL=isRestResponse.js.map